import { useEffect, useState } from 'react';
import { getCachedIconUrl, getIconPath, loadIcon } from 'components/ProductIcon/icons';

/* Loads product icon on demand. Returns src when loaded, null while loading or if no match. */
export const useProductIconSrc = (sku: string | undefined, label?: string): string | null => {
  const path = (sku ? getIconPath(sku.toLowerCase()) : null) ?? (label ? getIconPath(label.toLowerCase()) : null);
  const [src, setSrc] = useState<string | null>(() => (path ? getCachedIconUrl(path) : null));

  useEffect(() => {
    if (!path) {
      setSrc(null);
      return;
    }

    const cached = getCachedIconUrl(path);
    if (cached) {
      setSrc(cached);
      return;
    }

    let cancelled = false;
    loadIcon(path).then((url) => {
      if (!cancelled && url) setSrc(url);
    });

    return () => {
      cancelled = true;
    };
  }, [path]);

  return src;
};
